import React from 'react';
import PropTypes from 'prop-types';

import {
    Flex,
    Spacer,
} from '@zillow/constellation';
import { TransitionWrapper, Center } from '@zillow/zrs-comet';

import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';

import {
    StyledWideLayoutContainer,
    StyledBodyContainer,
    StyledContentContainer,
    StyledDescriptionContainer,
    StyledIcon,
    StyledCenterParagraph,
    StyledDesktopTitleParagraph,
    StyledMobileTitleParagraph,
} from './StyledComponents';


const propTypes = {
    children: PropTypes.node.isRequired,
    description: PropTypes.node,
    icon: PropTypes.node,
    isTransitioning: PropTypes.bool,
    hasError: PropTypes.bool,
    subtitle: PropTypes.node,
    title: PropTypes.string.isRequired,
    mobileTitle: PropTypes.node,
    footer: PropTypes.node,
    progressStepper: PropTypes.node,
};

const defaultProps = {
    description: '',
    icon: null,
    isTransitioning: false,
    hasError: false,
    subtitle: '',
    mobileTitle: '',
    footer: null,
    progressStepper: null,
};

const WizardBodyTemplate = ({
    children,
    description,
    icon,
    isTransitioning,
    hasError,
    subtitle,
    title,
    mobileTitle,
    footer,
    progressStepper,
}) => {
    const renderError = () => (
        <Center fontColor="red600">
            {ErrorMessageConstants.DEFAULT_ERROR}
        </Center>
    );

    const renderContent = () => (
        <>
            <Spacer mediaQuery={{ lg: { marginX: 'lg' } }}>
                {icon && (
                    <Flex display="flex" flexDirection="column" alignItems="center" paddingBottom="lg">
                        <StyledIcon>
                            {icon}
                        </StyledIcon>
                    </Flex>
                )}
                <Spacer paddingBottom="xs">
                    <StyledDesktopTitleParagraph fontType="h3">
                        {title}
                    </StyledDesktopTitleParagraph>
                    {mobileTitle ? (
                        <StyledMobileTitleParagraph
                            fontType="h4"
                        >
                            {mobileTitle}
                        </StyledMobileTitleParagraph>
                    ) :
                        <StyledMobileTitleParagraph fontType="h4">{title}</StyledMobileTitleParagraph>}
                    {subtitle && (
                        <Spacer paddingTop="xs">
                            <StyledCenterParagraph fontType="body" data-test="subtitle" className="subtitle">
                                {subtitle}
                            </StyledCenterParagraph>
                        </Spacer>
                    )}
                    {description && (
                        <StyledDescriptionContainer>
                            <StyledCenterParagraph fontType="body" data-test="description">
                                {description}
                            </StyledCenterParagraph>
                        </StyledDescriptionContainer>
                    )}
                </Spacer>
            </Spacer>
            {children}
        </>
    );

    return (isTransitioning ? (
        <StyledBodyContainer>
            <StyledWideLayoutContainer>
                <StyledContentContainer
                    alignSelf="center"
                    borderRounded={true}
                    backgroundColor="white"
                    display="flex"
                    flexDirection="column"
                >
                    {progressStepper}
                    <TransitionWrapper isTransitioning={true} />
                </StyledContentContainer>
            </StyledWideLayoutContainer>
        </StyledBodyContainer>
    ) : (
        <>
            <StyledBodyContainer>
                <StyledWideLayoutContainer>
                    <StyledContentContainer
                        alignSelf="center"
                        borderRounded={true}
                        backgroundColor="white"
                        display="flex"
                        flexDirection="column"
                    >
                        <Spacer marginBottom="lg">
                            {progressStepper}
                        </Spacer>
                        {hasError ? renderError() : renderContent()}
                    </StyledContentContainer>
                    <Spacer marginX={17} marginTop="lg" marginBottom={11}>
                        {footer}
                    </Spacer>
                </StyledWideLayoutContainer>
            </StyledBodyContainer>
        </>
    ));
};

WizardBodyTemplate.propTypes = propTypes;
WizardBodyTemplate.defaultProps = defaultProps;

export default WizardBodyTemplate;
